export const NS_DEFAULT = 'translation';
export const NS_HEADER = 'header';
export const NS_FOOTER = 'footer';
export const NS_ERROR = 'error';
export const NS_QUOTATION = 'quotation';
export const NS_PLAN = 'plan';
export const NS_QUESTIONNAIRE = 'questionnaire';
export const NS_APPLICATION = 'application';
export const NS_REVIEW = 'review';
export const NS_PAYMENT = 'payment';
export const NS_STEPPER = 'stepper';
export const NS_DOCUMENT = 'document';
export const NS_COMMON = 'common';
